import ToggleTabs from '@/components/toggle-tabs';
import { FC } from 'react';

interface Props {
  onChange: (tabPath: string) => void;
}

const BrandingThemeTabs: FC<Props> = ({ onChange }) => {
  return (
    <ToggleTabs
      onChange={onChange}
      panels={[
        {
          label: 'Light Theme',
          path: 'light',
          icon: 'light-mode',
        },
        {
          label: 'Dark Theme',
          path: 'dark',
          icon: 'dark-mode',
        },
      ]}
    />
  );
};

export default BrandingThemeTabs;
